import { render, staticRenderFns } from "./VaIconMessage.vue?vue&type=template&id=73342005"
import script from "./VaIconMessage.vue?vue&type=script&lang=js"
export * from "./VaIconMessage.vue?vue&type=script&lang=js"
import style0 from "./VaIconMessage.vue?vue&type=style&index=0&id=73342005&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports